function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("./utils"),
    num2str = _require.num2str,
    Emitter = _require.Emitter;

function getMatch(str, pos, pattern) {
  var i = 0,
      strQ = str.toUpperCase(),
      patternQ = pattern.toUpperCase();

  while (strQ[pos + i] && strQ[pos + i] == patternQ[i]) {
    i++;
  }

  return str.substr(pos, i);
}

function getInteger(str, pos) {
  str = str.substring(pos);
  var match = str.match(/^\d+/);
  return match && match[0];
}

function parseNode(text, token, pos) {
  var result = parseToken(text, token, pos); // check placeholder

  if (result.err && token.type != "static" && text.startsWith(token.placeholder, pos) && (result.err > 1 || result.viewValue.length <= token.placeholder.length)) {
    return {
      empty: true,
      viewValue: token.placeholder
    };
  }

  return result;
}

function parseToken(text, token, pos) {
  var m, match, value, j;

  if (token.type == "static") {
    if (!text.startsWith(token.value, pos)) {
      return {
        err: 2,
        code: "TEXT_MISMATCH",
        message: "Pattern value mismatch"
      };
    }

    return {
      viewValue: token.value
    };
  }

  if (token.type == "number") {
    value = getInteger(text, pos);

    if (value == null) {
      return {
        err: 1,
        code: "NUMBER_MISMATCH",
        message: "Invalid number",
        viewValue: ""
      };
    }

    if (value.length < token.minLength) {
      return {
        err: 1,
        code: "NUMBER_TOOSHORT",
        message: "The length of number is too short",
        value: +value,
        viewValue: value,
        properValue: num2str(+value, token.minLength, token.maxLength)
      };
    }

    if (value.length > token.maxLength) {
      value = value.substr(0, token.maxLength);
    }

    if (+value < token.min) {
      return {
        err: 1,
        code: "NUMBER_TOOSMALL",
        message: "The number is too small",
        value: +value,
        viewValue: value,
        properValue: num2str(token.min, token.minLength, token.maxLength)
      };
    }

    if (value.length > token.minLength && value[0] == "0") {
      return {
        err: 1,
        code: "LEADING_ZERO",
        message: "The number has too many leading zero",
        value: +value,
        viewValue: value,
        properValue: num2str(+value, token.minLength, token.maxLength)
      };
    }

    if (+value > token.max) {
      return {
        err: 1,
        code: "NUMBER_TOOLARGE",
        message: "The number is too large",
        value: +value,
        viewValue: value,
        properValue: num2str(token.max, token.minLength, token.maxLength)
      };
    }

    return {
      value: +value,
      viewValue: value
    };
  }

  if (token.type == "select") {
    match = "";

    for (j = 0; j < token.select.length; j++) {
      m = getMatch(text, pos, token.select[j]);

      if (m && m.length > match.length) {
        value = j;
        match = m;
      }
    }

    if (!match) {
      return {
        err: 1,
        code: "SELECT_MISMATCH",
        message: "Invalid select",
        viewValue: ""
      };
    }

    if (match != token.select[value]) {
      return {
        err: 1,
        code: "SELECT_INCOMPLETE",
        message: "Incomplete select",
        value: value + 1,
        viewValue: match,
        selected: token.select[value]
      };
    }

    return {
      value: value + 1,
      viewValue: match
    };
  }

  throw "Unknown token type: " + token.type;
}

function parseNodes(nodes, text) {
  var pos = 0,
      node,
      result = [],
      r;

  var _iterator = _createForOfIteratorHelper(nodes),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      node = _step.value;
      r = parseNode(text, node.token, pos);
      r.node = node;
      r.pos = pos;
      r.token = node.token;

      if (r.err >= 2) {
        r.text = text;
        throw r;
      }

      pos += r.viewValue.length;
      result.push(r);
    } // throw TEXT_TOOLONG error

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var last = result[result.length - 1];

  if (last.pos + last.viewValue.length < text.length) {
    throw {
      code: "TEXT_TOOLONG",
      message: "Text is too long",
      text: text
    };
  }

  return result;
}

function formatNode(value, token) {
  if (token.type == "static") {
    return {
      viewValue: token.value
    };
  }

  var v = token.extract(value);

  if (token.type == "number") {
    return {
      value: v,
      viewValue: num2str(v, token.minLength, token.maxLength)
    };
  }

  if (token.type == "select") {
    return {
      value: v,
      viewValue: token.select[v - 1]
    };
  }

  throw "Unknown type to format: " + token.type;
}

function formatNodes(value, nodes, ignoreEmpty) {
  var result = [],
      r,
      node;

  var _iterator2 = _createForOfIteratorHelper(nodes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      node = _step2.value;
      r = formatNode(value, node.token);

      if (node.token.type != "static" && node.empty && !ignoreEmpty) {
        r.value = null;
        r.viewValue = node.token.placeholder;
      }

      result.push(r);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return result;
}

var Node = /*#__PURE__*/function () {
  function Node(parser, token) {
    _classCallCheck(this, Node);

    this.parser = parser;
    this.token = token;
    this.value = null;
    this.viewValue = token.value;
    this.offset = 0;
    this.next = null;
    this.prev = null;
    this.nextEdit = null;
    this.prevEdit = null;
    this.empty = true;
  }

  _createClass(Node, [{
    key: "unset",
    value: function unset() {
      if (this.token.type == "static" || this.parser.noEmpty) {
        return;
      }

      this.empty = true;
      this.parser.setValue(this.parser.value, false);
    }
  }, {
    key: "parse",
    value: function parse(text) {
      var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var result = parseNode(text, this.token, pos);

      if (result.err) {
        result.node = this;
        result.token = this.token;
        throw result;
      }

      if (this.parser.noEmpty && result.empty) {
        throw {
          code: "NOT_INIT_FORBIDDEN",
          message: "Empty node is forbidden",
          node: this
        };
      }

      if (result.empty) {
        this.unset();
        return;
      }

      this.empty = false;
      var value = restoreValue(this.parser.copyValue(this.parser.value), this.token, result.value, this.parser);
      this.parser.setValue(value, false);
    }
  }, {
    key: "add",
    value: function add(diff) {
      var value = this.parser.copyValue(this.parser.value),
          nodeValue;
      this.empty = false;
      value = addValue(value, this.token, diff, this.parser);
      nodeValue = this.token.extract(value); // min/max check

      var min, max;

      if (this.token.type == "number") {
        min = this.token.min;
        max = this.token.max;
      } else if (this.token.type == "select") {
        min = 1;
        max = this.token.select.length;
      }

      if (nodeValue < min) {
        value = restoreValue(value, this.token, min, this.parser);
      }

      if (nodeValue > max) {
        value = restoreValue(value, this.token, max, this.parser);
      }

      this.parser.setValue(value, false);
    }
  }]);

  return Node;
}();

function addValue(o, tk, v, p) {
  if (_typeof(o) == "object") {
    tk.add(o, v, p);
    return o;
  } else {
    return tk.add(o, v, p);
  }
}

function restoreValue(o, tk, v, p) {
  if (_typeof(o) == "object") {
    tk.restore(o, v, p);
    return o;
  } else {
    return tk.restore(o, v, p);
  }
}

function createNodes(parser, tokens) {
  var tk,
      i,
      edit,
      nodes = [];

  var _iterator3 = _createForOfIteratorHelper(tokens),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      tk = _step3.value;
      nodes.push(new Node(parser, tk));
    } // Build relationship between nodes

  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  for (i = 0; i < nodes.length; i++) {
    nodes[i].next = nodes[i + 1] || null;
    nodes[i].prev = nodes[i - 1] || null;
  }

  edit = null;

  for (i = 0; i < nodes.length; i++) {
    nodes[i].prevEdit = edit;

    if (nodes[i].token.type != "static") {
      edit = nodes[i];
    }
  }

  edit = null;

  for (i = nodes.length - 1; i >= 0; i--) {
    nodes[i].nextEdit = edit;

    if (nodes[i].token.type != "static") {
      edit = nodes[i];
    }
  }

  return nodes;
}

function nocopy(o) {
  return o;
}

function createNameMap(nodes) {
  var map = new Map();

  var _iterator4 = _createForOfIteratorHelper(nodes),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var node = _step4.value;
      var l = map.get(node.token.name);

      if (!l) {
        l = [];
        map.set(node.token.name, l);
      }

      l.push(node);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return map;
} // a stated text parser


var TextParser = /*#__PURE__*/function (_Emitter) {
  _inherits(TextParser, _Emitter);

  var _super = _createSuper(TextParser);

  function TextParser() {
    var _this;

    _classCallCheck(this, TextParser);

    _this = _super.call(this);

    _this._constructor.apply(_assertThisInitialized(_this), arguments);

    _this.initialize();

    return _this;
  }

  _createClass(TextParser, [{
    key: "_constructor",
    value: function _constructor(_ref) {
      var tokens = _ref.tokens,
          _ref$noEmpty = _ref.noEmpty,
          noEmpty = _ref$noEmpty === void 0 ? false : _ref$noEmpty,
          value = _ref.value,
          text = _ref.text,
          _ref$copyValue = _ref.copyValue,
          copyValue = _ref$copyValue === void 0 ? nocopy : _ref$copyValue;

      if (!tokens || !tokens.length) {
        throw new Error("option.tokens is required");
      }

      this.tokens = tokens;
      this.nodes = createNodes(this, tokens);
      this.nameMap = createNameMap(this.nodes);
      this.value = value;
      this.text = text;
      this.noEmpty = noEmpty;
      this.copyValue = copyValue;
      this.err = false;
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this.setValue(this.value);
    }
  }, {
    key: "parse",
    value: function parse(text) {
      if (!text) {
        throw {
          code: "EMPTY",
          message: "The input is empty",
          oldText: this.text
        };
      }

      var result, i;
      result = parseNodes(this.nodes, text); // grab changed nodes

      var changed = [],
          comparer;

      if (this.err) {
        comparer = parseNodes(this.nodes, this.text);
      } else {
        comparer = this.nodes;
      }

      for (i = 0; i < result.length; i++) {
        if (!result[i].empty && result[i].viewValue != comparer[i].viewValue) {
          // expose token for sorting and consistent check
          result[i].token = this.nodes[i].token;
          changed.push(result[i]);
        }
      } // grab empty nodes


      var empties = result.filter(function (r) {
        return r.empty;
      }),
          errors = result.filter(function (r) {
        return r.err;
      }); // copy result value into nodes

      for (i = 0; i < result.length; i++) {
        this.nodes[i].value = result[i].value;
        this.nodes[i].viewValue = result[i].viewValue;
        this.nodes[i].offset = result[i].pos;
        this.nodes[i].empty = result[i].empty;
      } // throw error


      if (errors.length) {
        this.err = true;
        throw errors[0];
      } else {
        this.err = false;
      } // sort result


      changed.sort(function (a, b) {
        if (b.empty) {
          return -1;
        }

        if (a.empty) {
          return 1;
        }

        return (b.token.prior || 0) - (a.token.prior || 0);
      }); // consistent check

      var c,
          value = this.copyValue(this.value);

      for (var _i = 0, _changed = changed; _i < _changed.length; _i++) {
        c = _changed[_i];
        value = restoreValue(value, c.token, c.value, this);
      }

      var newText = formatNodes(value, result).map(function (r) {
        return r.viewValue;
      }).join("");

      if (text != newText) {
        this.err = true;
        throw {
          code: "INCONSISTENT_INPUT",
          message: "Successfully parsed but the output text doesn't match the input",
          text: text,
          oldText: this.text,
          properText: newText
        };
      } // Done. Manipulate value and text


      this.text = text;
      this.value = value;
      this.emit("change", this.value); // throw not_init error

      if (empties.length) {
        throw {
          code: "NOT_INIT",
          message: "Some nodes are empty",
          text: text,
          node: empties[0]
        };
      }

      return this;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      var ignoreEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // value => text
      var result = formatNodes(value, this.nodes, ignoreEmpty);
      var i,
          pos = 0,
          text = "";

      for (i = 0; i < result.length; i++) {
        this.nodes[i].value = result[i].value;
        this.nodes[i].viewValue = result[i].viewValue;
        this.nodes[i].offset = pos;
        this.nodes[i].empty = ignoreEmpty ? false : this.nodes[i].empty;
        pos += this.nodes[i].viewValue.length;
        text += this.nodes[i].viewValue;
      }

      this.value = value;
      this.text = text;
      this.emit("change", this.value);
      return this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(text) {
      var result;

      if (text) {
        try {
          result = parseNodes(this.nodes, text);
        } catch (err) {
          return false;
        }
      } else {
        result = this.nodes;
      }

      var i;

      for (i = 0; i < result.length; i++) {
        if (this.nodes[i].token.type != "static" && !result[i].empty) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "isInit",
    value: function isInit() {
      var node;

      var _iterator5 = _createForOfIteratorHelper(this.nodes),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          node = _step5.value;

          if (node.token.type != "static" && node.empty) {
            return false;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return true;
    }
  }, {
    key: "unset",
    value: function unset() {
      var node;

      var _iterator6 = _createForOfIteratorHelper(this.nodes),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          node = _step6.value;
          node.empty = true;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      this.setValue(this.value, false);
      return this;
    }
  }, {
    key: "getText",
    value: function getText() {
      return this.text;
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.value;
    }
  }, {
    key: "getNodes",
    value: function getNodes(name) {
      if (name) {
        return this.nameMap.get(name);
      }

      return this.nodes;
    }
  }]);

  return TextParser;
}(Emitter);

module.exports = {
  TextParser: TextParser
};